module.exports = __webpack_public_path__ + "images/emoji/de.c9e86673b42dd21c2374.png";